import { render } from "./Newsletter.vue?vue&type=template&id=1146bcae&scoped=true&ts=true"
import script from "./Newsletter.vue?vue&type=script&setup=true&lang=ts"
export * from "./Newsletter.vue?vue&type=script&setup=true&lang=ts"

import "./Newsletter.vue?vue&type=style&index=0&id=1146bcae&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1146bcae"],['__file',"src/components/home/Newsletter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1146bcae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1146bcae', __exports__)) {
    console.log('reload')
    api.reload('1146bcae', __exports__)
  }
  
  module.hot.accept("./Newsletter.vue?vue&type=template&id=1146bcae&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('1146bcae', render)
  })

}


export default __exports__